import { useStyletron } from '@thanx/uikit/theme'
import BellIcon from 'assets/images/BellIcon'
import { userIsAuthenticated } from 'auth'
import LaunchNotesEmbed from 'components/LaunchNotes'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import useCurrentMerchantUser from 'hooks/useCurrentMerchantUser'
import React from 'react'
import { Nav } from 'react-bootstrap-five'
import { merchantTheme } from 'theme'
import { useIsDesktop } from 'utilities/responsive'

const LaunchNotes: React.FC = () => {
  const [css] = useStyletron()
  const embedId = process.env.REACT_APP_LAUNCHNOTES_EMBED_ID
  const embedToken = process.env.REACT_APP_LAUNCHNOTES_EMBED_TOKEN
  const isDesktop = useIsDesktop()
  const merchant = useCurrentMerchant()
  const merchantUser = useCurrentMerchantUser()

  if (!embedId || !embedToken) return null

  const handleClick = () => {
    // React's dynamic DOM breaks LaunchNotes' automatic click binding,
    // so we call togglePanel() directly per LaunchNotes React docs.
    if (window.launchnotesEmbed?.togglePanel) {
      window.launchnotesEmbed.togglePanel()
    }
  }

  return (
    <>
      <Nav.Item
        id="ln-embed"
        className={`d-flex align-items-center ${css({
          padding: '10px 11px 10px ' + (isDesktop ? '8px' : '10px'),
          display: 'inline-block',
          cursor: 'pointer',
          color: merchantTheme.colors.grey30,
          ':hover': {
            backgroundColor: merchantTheme.colors.grey100,
            color: merchantTheme.colors.white,
          },
          ':focus': {
            backgroundColor: merchantTheme.colors.grey100,
            color: merchantTheme.colors.white,
          },
        })}`}
        onClick={handleClick}
      >
        <BellIcon />
      </Nav.Item>
      <LaunchNotesEmbed
        embedId={embedId}
        embedToken={embedToken}
        viewerId={`${merchant?.id}-${merchantUser?.id}`}
      />
    </>
  )
}

export default userIsAuthenticated(LaunchNotes)
